import { Injectable, NgZone } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';

import { AuthPartialState } from './auth.reducer';
import {
  Login,
  LoginSuccess,
  LoginFail,
  AuthActionTypes,
  GetUserDetails,
  GetUserdetailsSuccess,
  GetUserdetailsFail
} from './auth.actions';
import { map, filter, tap } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthEffects {
  @Effect()
  login$ = this.dataPersistence.fetch(AuthActionTypes.LOGIN, {
    run: (action: Login, state: AuthPartialState) => {
      return this.service
        .login(action.payload)
        .pipe(map(user => new LoginSuccess(user)));
    },

    onError: (action: Login, error) => {
      return new LoginFail(error);
    }
  });


  @Effect()
  getUserDetails$ = this.dataPersistence.fetch(
    AuthActionTypes.GET_USER_DETAILS,
    {
      run: (action: GetUserDetails, state: AuthPartialState) => {
        return this.service
          .get()
          .pipe(map(user => new GetUserdetailsSuccess(user)));
      },

      onError: (action: GetUserDetails, error) => {
        return new GetUserdetailsFail(error);
      }
    }
  );

  @Effect({ dispatch: false })
  logout$ = this.actions$.pipe(
    filter(action => action.type === AuthActionTypes.LOGOUT),
    map(() => {
      this.service.purgeAuth();
      this.ngZone.run(() => this.router.navigate(['/login'])).then();
    })
  );

  @Effect({ dispatch: false })
  loginRedirect$ = this.actions$.pipe(
    filter(action => action.type === AuthActionTypes.LOGIN_SUCCESS),
    tap(() => this.router.navigate(['/dashboard']))
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<AuthPartialState>,
    private ngZone: NgZone,
    private service: AuthService,
    private router: Router
  ) { }
}
